// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar_MPV0Z {
  border: 1px solid #e7eaef; 
  margin-bottom:16px
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/installGateway/InstallationDetails.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB;AACF","sourcesContent":[".bar {\n  border: 1px solid #e7eaef; \n  margin-bottom:16px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `bar_MPV0Z`
};
export default ___CSS_LOADER_EXPORT___;
